<template>
  <search-layout>
    <template v-slot:contents>
      <field-input title="기간" cols="2">
        <date-input
          :start-date="startDate"
          :end-date="endDate"
          @updateDate="updateDate"
        />
      </field-input>
      <field-input title="조직" cols="2">
        <v-select
          v-model="orgCd"
          :items="orgList"
          item-text="text"
          item-value="value"
          outlined hide-details dense
          background-color="white"
          @change="changeOrg"
        />
      </field-input>
      <field-input title="사용자" cols="2">
        <v-select
          v-model="id"
          :items="memberList"
          item-text="memberNm"
          item-value="id"
          outlined hide-details dense
          background-color="white"
          :disabled="!selectOrgCd"
        />
      </field-input>
    </template>
    <template v-slot:button>
      <search-btn @click="search" />
    </template>
  </search-layout>
</template>
<script>
import SearchLayout from "@/common/layout/SearchLayout.vue";
import SearchBtn from "@/common/components/SearchBtn.vue";
import FieldInput from "@/common/components/input/FieldInput.vue";
import DateInput from "@/common/components/input/DateInput.vue";
import DateMixin from "@/mixin/DateMixin";
import func from "@/util/func";
import {axiosInstance} from "@/util/AxiosModule";
import {mapGetters} from "vuex";

export default {
  name: "ServiceLogSearchBar",
  components: {DateInput, FieldInput, SearchBtn, SearchLayout},
  mixins: [DateMixin],
  data() {
    return {
      startDate: "",
      endDate: "",
      orgCd: "",
      orgList: [],
      id: "",
      memberList: [
        { memberNm: "전체", id: "" }
      ]
    }
  },
  beforeMount() {
    const { fromDate, toDate } = this.setDateDiff(-31);
    this.startDate = fromDate;
    this.endDate = toDate;
  },
  mounted() {
    this.getOrgList();
  },
  computed: {
    ...mapGetters("login", {memberId: "memberId"}),
    selectOrgCd() {
      return this.orgCd !== "";
    }
  },
  methods: {
    async getOrgList() {
      const list = await func.getOrgList("", "Y", "N", "");
      this.orgList = this.findTypeItem(list, "ORG");
      this.orgList.unshift({text: "전체", value: ""});
    },
    findTypeItem(list, type) {
      let resultList = [];
      const excludeList = ["1000"]; // 제외 목록
      for (const item of list) {
        if (!excludeList.includes(item.id) && item.type === type) {
          resultList.push({text: item.name, value: item.id});
        }
        if (item.children && item.children.length) {
          const found = this.findTypeItem(item.children, type);
          if (found) {
            resultList = resultList.concat(found);
          }
        }
      }
      return resultList;
    },
    async changeOrg(orgCd) {
      if (orgCd === "") return;
      try {
        const { data } = await axiosInstance.get("/private/member/list", {
          params: {
            memberId: this.memberId,
            orgCd: orgCd,
            name: "",
            delYn: "N"
          }
        });
        if (data.length < 1) {
          this.memberList = [];
        } else {
          this.memberList = data;
          this.memberList.unshift({memberNm: "전체", id: ""});
        }
      } catch (e) {
        await this.showAlert({
          message: `${e.response.data.message}`
        })
      }
    },
    updateDate(value) {
      this.startDate = value[0];
      this.endDate = value[1];
    },
    search() {
      const params = {
        stDt: this.startDate.replaceAll("-", ""),
        edDt: this.endDate.replaceAll("-", ""),
        orgCd: this.orgCd,
        id: this.id
      };
      this.$emit("search", params);
    }
  }
}
</script>